import React, { useState, useEffect } from 'react';
import _ from 'lodash'
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import {
    Box, Grid, Typography, IconButton, Divider, Popover, TextField, List, ListItem, ListItemIcon, Select, MenuItem, Button, FormGroup, FormControlLabel,
    Checkbox, DialogActions, Stack, Modal, Fade, InputAdornment
} from '@mui/material';
import toast from 'react-hot-toast';
import DatePicker from "react-datepicker";
import moment from 'moment'
/***************Component Import********************/
import { HandleMeasureIcon } from '../../../components/measureList/MeasureListConfig';
import { TIME_GRANULARITIES, GRANULARITY_DATE_RANGE, COMPARE_DATE_RANGE } from '../../../constants/granularity';
import { UtcToLocalDate, LocalToUTC } from '../../../utils/Reusables';
import { ReactComponent as InputSearchIcon } from "../../../assets/icons/icon-feather-search.svg"
/***************Component Import End****************/

/***********Icons Import**********/
import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close';
/***********Icons Import End**********/


/**********Services Import*****************/
import { getMeasuresList } from '../../../config/services/measures';
/**********Services Import End*****************/

import { useRef } from "react";
import { ReactComponent as CancelIcon } from "../../../assets/icons/icon-cancel.svg";
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg"


const RootStyle = styled('div')(({ theme }) => ({

}));


const useStyles = makeStyles((theme) => ({
    crossIcon: {
        '& svg': {
            fontSize: 18
        }
    },
    bgWhite: {
        backgroundColor: '#fff',
        borderRadius: '4px',
    },
    formInput: {
        paddingLeft: 0,
        '&::placeholder': {
            paddingLeft: '-10px',
        }
    },
    searchFieldListItem: {
        paddingTop: '0.6rem',
        paddingBottom: '0.6rem',
        '&:hover': {
            background: "#f1f1f1",
            backgroundColor: "#f1f1f1",
            zIndex: 9,
            "& $listItemDescription": {
                visibility: 'visible'
            },
            "& $searchFieldListMoreIcon": {
                visibility: 'visible'
            }
        },

    },
    listItemDescription: {
        visibility: 'visible',
        '&:hover': {
            visibility: 'visible'
        }
    },
    searchFieldListMoreIcon: {
        visibility: 'visible',
        '&:hover': {
            visibility: 'visible'
        }
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }
}));

export default function DashboardGranularity(props) {
    let { reportDetails, updateReportDetails, granularityOptions,
        addGranularityToSheet, sheetsAvailable, setSheetsAvailable,
        selectedSheetIndex, applyGranularityToAllReports, removeGranularityFrmAllReports } = props

    const [anchorAddGranularity, setAnchorAddGranularity] = useState(null);
    const [measureList, setMeasureList] = useState([])
    const [searchMeasure, setSearchMeasure] = useState(null);
    const [datasetSelectedId, setDatasetSelectedId] = useState(reportDetails?.reportDetails?.dataSetId?._id);
    const [timeDimensions, setTimeDimensions] = useState(reportDetails?.reportDetails?.timeDimensions || []);
    const [deleteGranularitiesDialog, setDeleteGranularitiesDialog] = useState(false)
    const [tempSelectedGran, setTempSelectedGran] = useState({})
    const [deleteSingleGranDialog, setDeleteSingleGranDialog] = useState(false)
    const [filterButtonWidth, setFilterButtonWidth] = useState('200px')

    const buttonGranulRef = useRef();

    const classes = useStyles();

    const fetchMeasureList = () => {
        let params = { dataSetId: datasetSelectedId, search: searchMeasure, sortKey: 'name', sortOrder: 1 }
        getMeasuresList(params)
            .then((res) => {
                if (res?.data?.statusCode === 0) { //Error Case
                    toast.error(res?.data?.error?.errorMessage || 'Error while fetching measures')
                }

                let timeMeasures = res?.result?.filter(obj => obj.type === 'time')
                setMeasureList(timeMeasures);
            });
    }

    const handleMeaureMenu = (event) => {
        const buttonWidth = buttonGranulRef.current.clientWidth;
        setFilterButtonWidth(buttonWidth);
        setSearchMeasure('');
        setAnchorAddGranularity(event.currentTarget)
    }

    const closeMeasureMenu = (event) => {
        setSearchMeasure('');
        setAnchorAddGranularity(null)
    }

    const handleSearchMeasure = (e) => {
        let { value } = e.target
        setSearchMeasure(value)
    }

    const clickMeasureListHandler = (measure) => {
        let { dataSetName } = reportDetails?.reportDetails?.dataSetId
        let updatedTimeDimensions = [...timeDimensions]
        let defaultStartDate = moment().startOf('day').toISOString()
        let defaultEndDate = moment().endOf('day').toISOString()

        let dimensionObj = {
            dimension: `${dataSetName}.${measure.name}`,
            dateRangeArray: [defaultStartDate, defaultEndDate],
            dateRangeType: 'custom',
            granularity: 'null',
            displayTitle: measure?.displayName || measure?.name,
            compareDateRange: [],
            compareDateRangeEnabled: false,
        }

        let checkDimensionExist = updatedTimeDimensions.findIndex(dim => dim.dimension === dimensionObj.dimension)

        if (checkDimensionExist < 0) {
            updatedTimeDimensions.unshift(dimensionObj)
        }
        else {
            toast.error('Field already added!')
        }

        setTimeDimensions(updatedTimeDimensions)
        closeMeasureMenu()
    }

    const addGranularityToSheetHandler = (measure) => {
        addGranularityToSheet(measure)
        closeMeasureMenu()
    }

    const handleRemoveMeasure = (action, dimension, i) => {
        switch (action) {
            case 'open':
                let selectedGranularity = { ...dimension, index: i }
                setTempSelectedGran(selectedGranularity)
                setDeleteSingleGranDialog(true)
                break
            case 'close':
                setTempSelectedGran({})
                setDeleteSingleGranDialog(false)
                break
        }
    }

    const handleDeleteGranularity = () => {
        let { index } = tempSelectedGran
        let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
        sheetsWithoutReference[selectedSheetIndex]?.sheetGranularities?.splice(index, 1);

        handleRemoveMeasure('close')
        setSheetsAvailable(sheetsWithoutReference)
    }

    const handleDateSelect = (date, i, key) => {
        let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
        let updatedTimeDimensions = sheetsWithoutReference[selectedSheetIndex]?.sheetGranularities

        if (key === 'startDate')
            updatedTimeDimensions[i].dateRangeArray[0] = moment(date).startOf('day').toISOString()

        else if (key === 'endDate')
            updatedTimeDimensions[i].dateRangeArray[1] = moment(date).endOf('day').toISOString()

        setSheetsAvailable(sheetsWithoutReference)
    }

    const handleGranularity = (e, i) => {
        let { value } = e.target
        let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
        let updatedTimeDimensions = sheetsWithoutReference[selectedSheetIndex]?.sheetGranularities
        updatedTimeDimensions[i].granularity = value

        setSheetsAvailable(sheetsWithoutReference)
    }

    const handleDateRangeType = (e, i) => {
        let defaultStartDate = moment().startOf('day').toISOString()
        let defaultEndDate = moment().endOf('day').toISOString()
        let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
        let updatedTimeDimensions = sheetsWithoutReference[selectedSheetIndex]?.sheetGranularities
        let { value } = e.target

        if (value === 'custom') {
            updatedTimeDimensions[i].dateRangeType = 'custom'
            updatedTimeDimensions[i].dateRangeArray = [defaultStartDate, defaultEndDate]
            delete updatedTimeDimensions[i].dateRange
        }
        else if (value === 'allTime') {
            updatedTimeDimensions[i].dateRangeType = value
            updatedTimeDimensions[i].dateRangeArray = []
            delete updatedTimeDimensions[i].dateRange
            delete updatedTimeDimensions[i].dateRangeArray
        }
        else {
            updatedTimeDimensions[i].dateRange = value
            updatedTimeDimensions[i].dateRangeType = value
            delete updatedTimeDimensions[i].dateRangeArray
        }

        setSheetsAvailable(sheetsWithoutReference)
    }

    const handleApplyGranulairty = () => {
        let updatedTimeDimensions = [...timeDimensions]
        reportDetails.reportDetails.timeDimensions = updatedTimeDimensions
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleDeleteAllGranularities = () => {
        removeGranularityFrmAllReports()
        handleDeleteAllGranularitiesDialog('close')
    }

    const handleCompareDateRange = (e, dimension, i) => {
        let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
        let updatedTimeDimensions = sheetsWithoutReference[selectedSheetIndex]?.sheetGranularities
        let { checked } = e.target

        if (checked === false) {
            updatedTimeDimensions[i].compareDateRange = []
        }
        else {// To add first compare by default
            if (updatedTimeDimensions[i]?.dateRangeType === 'allTime') {
                updatedTimeDimensions[i]?.compareDateRange.push({ type: 'Today', startDate: null, endDate: null, fixedValue: 'Today' })
            }
            else if (updatedTimeDimensions[i]?.dateRangeType === 'custom') {
                updatedTimeDimensions[i]?.compareDateRange.push({ type: 'custom', startDate: updatedTimeDimensions[i]?.dateRangeArray[0], endDate: updatedTimeDimensions[i]?.dateRangeArray[1], fixedValue: 'custom' })
            }
            else {
                updatedTimeDimensions[i]?.compareDateRange.push({ type: updatedTimeDimensions[i]?.dateRange, startDate: null, endDate: null, fixedValue: updatedTimeDimensions[i]?.dateRange })
            }
        }

        updatedTimeDimensions[i].compareDateRangeEnabled = checked
        setSheetsAvailable(sheetsWithoutReference)
    }

    const handleAddCompareDateRange = (dimension, i) => {
        let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
        let updatedTimeDimensions = sheetsWithoutReference[selectedSheetIndex]?.sheetGranularities
        updatedTimeDimensions[i]?.compareDateRange.push({ type: 'Today', startDate: null, endDate: null, fixedValue: 'Today' })

        setSheetsAvailable(sheetsWithoutReference)
    }


    const handleDateCompareSelect = (date, compareDateIndex, TimeDimensionIndex, key) => {
        let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
        let updatedTimeDimensions = sheetsWithoutReference[selectedSheetIndex]?.sheetGranularities

        if (key === 'startDate' && updatedTimeDimensions?.[TimeDimensionIndex]?.compareDateRange?.[compareDateIndex]?.startDate)
            updatedTimeDimensions[TimeDimensionIndex].compareDateRange[compareDateIndex].startDate = UtcToLocalDate(moment(date).startOf('day').toISOString())

        else if (key === 'endDate' && updatedTimeDimensions?.[TimeDimensionIndex]?.compareDateRange?.[compareDateIndex]?.endDate)
            updatedTimeDimensions[TimeDimensionIndex].compareDateRange[compareDateIndex].endDate = UtcToLocalDate(moment(date).endOf('day').toISOString())

        setSheetsAvailable(sheetsWithoutReference)
    }


    const handleCompareDateRangeType = (e, compareDateIndex, TimeDimensionIndex) => {
        let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
        let updatedTimeDimensions = sheetsWithoutReference[selectedSheetIndex]?.sheetGranularities
        let { value } = e.target

        if (value === 'custom') {
            let defaultStartDate = moment().startOf('day').toISOString()
            let defaultEndDate = moment().endOf('day').toISOString()

            updatedTimeDimensions[TimeDimensionIndex].compareDateRange[compareDateIndex] = { type: value, startDate: defaultStartDate, endDate: defaultEndDate, fixedValue: value }
        }
        else {
            updatedTimeDimensions[TimeDimensionIndex].compareDateRange[compareDateIndex] = { type: value, startDate: null, endDate: null, fixedValue: value }
        }

        setSheetsAvailable(sheetsWithoutReference)
    }


    const handleRemoveDateCompare = (compareDateIndex, TimeDimensionIndex) => {
        let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
        let updatedTimeDimensions = sheetsWithoutReference[selectedSheetIndex]?.sheetGranularities
        updatedTimeDimensions[TimeDimensionIndex]?.compareDateRange?.splice(compareDateIndex, 1)

        setSheetsAvailable(sheetsWithoutReference)
    }

    const handleDeleteAllGranularitiesDialog = (isOpen) => {
        switch (isOpen) {
            case 'open':
                setDeleteGranularitiesDialog(true)
                break
            case 'close':
                setDeleteGranularitiesDialog(false)
                break
        }
    }

    useEffect(() => { fetchMeasureList() }, [datasetSelectedId, searchMeasure]);

    return (
        <RootStyle>
            <Box width="100%" height="10%" py={2}>
                <Grid container alignItems="center">
                    <Grid item xs>
                        <Typography gutterBottom variant="h5" className="filter-heading">Granularity</Typography>
                    </Grid>
                    <Button className="width-100 report_form_ui_btn primary" variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleMeaureMenu} ref={buttonGranulRef} >
                        Add Granularity Condition
                    </Button>
                </Grid>
                <Popover open={Boolean(anchorAddGranularity)} anchorEl={anchorAddGranularity} onClose={closeMeasureMenu}
                    PaperProps={{
                        style: {
                            width: filterButtonWidth, height: 'fit-content', maxHeight: '300px', borderTopLeftRadius: 0,
                            borderTopRightRadius: 0, marginTop: '10px', backgroundColor: 'transparent'
                        },
                    }}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
                    <div>
                        <Box width="100%" height="100%" block>
                            <TextField onChange={handleSearchMeasure} className="cm_rprt_setting_content report_form_ui_input" type="search" size="small"
                                placeholder="Search field"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            <InputSearchIcon className="input_search_icon" />
                                        </InputAdornment>
                                    ),
                                    classes: {
                                        input: classes.formInput,
                                        adornedEnd: classes.bgWhite + " form_input"
                                    }
                                }}
                            />
                        </Box>

                        <Box className="field_list report_filter_list height-fit max-width-100 mt-0" sx={{ maxHeight: '300px', backgroundColor: '#fff' }} >
                            <List component="nav" aria-label="main mailbox folders" className="field_list">
                                {
                                    (granularityOptions?.length)
                                        ? granularityOptions?.map((measure, i) => (
                                            <ListItem className={classes.searchFieldListItem} button key={i} onClick={() => addGranularityToSheetHandler(measure)}
                                                alignItems="flex-start">
                                                <ListItemIcon sx={{ mt: '0px', mr: '4px' }} className={classes.searchFieldListIcon + " icon_color_main"}> {HandleMeasureIcon(measure)}</ListItemIcon>
                                                <Grid container>
                                                    <Grid xs={12}>
                                                        <Typography className="text-plain"> {measure?.displayTitle ?? measure?.displayName} </Typography>
                                                    </Grid>
                                                </Grid>
                                            </ListItem>
                                        ))
                                        : <ListItem button >
                                            No DateTime Measure.
                                        </ListItem>
                                }
                            </List>
                        </Box>
                    </div>
                </Popover>
            </Box>

            <Box width="100%" height="50%" sx={{ p: 0 }} >
                {sheetsAvailable[selectedSheetIndex]?.sheetGranularities?.map((dimension, i) => (
                    <div key={i}>
                        <Grid container alignItems="center" mb={1} className="granularity_box granularity_item">
                            <Grid container alignItems="center">
                                <Grid item xs>
                                    <Typography variant="subtitle1" className="text-sub-heading" component="p">{dimension?.displayTitle}</Typography>
                                </Grid>

                                {/* <Grid item>
                                    <IconButton className='form-icon-btn' onClick={() => handleRemoveMeasure('open', dimension, i)} > <CancelIcon /> </IconButton>
                                </Grid> */}
                            </Grid>

                            <Grid container alignItems="center" mt={2}>
                                <Grid item xs={12}> <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Date Range</Typography></Grid>
                                <Grid item xs={12}>
                                    <Select value={dimension.dateRangeType} onChange={(e) => handleDateRangeType(e, i)} className='granularity_picker report_form_ui_input_select' size='small'
                                        IconComponent={DropDownIcon}
                                        MenuProps={{
                                            classes: {
                                                root: `form-select-menu`,
                                            },
                                        }}
                                    >
                                        {GRANULARITY_DATE_RANGE.map((obj, i) => <MenuItem className={classes.menuDropdownItem + " menu-item"} key={i} value={obj.value}>{obj.label}</MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>

                            {dimension.dateRangeType === 'custom' ?
                                <Grid container alignItems="center" mt={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Date Range</Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <DatePicker
                                            selected={new Date(dimension?.dateRangeArray[0])}
                                            onChange={(date) => handleDateSelect(date, i, 'startDate')}
                                            selectsStart
                                            startDate={new Date(dimension?.dateRangeArray[0])}
                                            endDate={new Date(dimension?.dateRangeArray[1])}
                                            className='date_picker report_form_ui_input'
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                        />
                                    </Grid>
                                    <Grid item xs={1}>
                                        To
                                    </Grid>

                                    <Grid item xs={5}>
                                        <DatePicker
                                            selected={new Date(dimension?.dateRangeArray[1])}
                                            onChange={(date) => handleDateSelect(date, i, 'endDate')}
                                            selectsEnd
                                            startDate={new Date(dimension?.dateRangeArray[0])}
                                            maxDate={new Date()} 
                                            endDate={new Date(dimension?.dateRangeArray[1])}
                                            minDate={new Date(dimension?.dateRangeArray[0])}
                                            className='date_picker report_form_ui_input'
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                        />
                                    </Grid>
                                </Grid> : null}

                            <Grid container alignItems="center" mt={2}>
                                <Grid item xs={12}> <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Time Granularity</Typography></Grid>
                                <Grid item xs={12}>
                                    <Select value={dimension.granularity} onChange={(e) => handleGranularity(e, i)} className='granularity_picker report_form_ui_input_select' size='small'
                                        IconComponent={DropDownIcon}
                                        MenuProps={{
                                            classes: {
                                                root: `form-select-menu`,
                                            },
                                        }}
                                    >
                                        {TIME_GRANULARITIES.map((obj, i) => <MenuItem className={classes.menuDropdownItem + " menu-item"} key={i} value={obj.value}>{obj.label}</MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>


                            <Grid container alignItems="center">
                                <Grid item xs>
                                    <FormGroup row>
                                        <FormControlLabel className="checkbox_font text-plain" control={<Checkbox className="form_checkbox" size='small' checked={dimension.compareDateRangeEnabled} name="compareDateRangeEnabled" onClick={(e) => handleCompareDateRange(e, dimension, i)} />} label="Compare Date-Range" />
                                    </FormGroup>
                                </Grid>

                                {dimension.compareDateRangeEnabled ?
                                    <Grid item>
                                        <IconButton className='form-icon-btn' color="primary" onClick={(e) => handleAddCompareDateRange(dimension, i)} title='Add Dates to compare'> <AddIcon /> </IconButton>
                                    </Grid> : null}
                            </Grid>


                            {dimension?.compareDateRange?.map((date, compareDateIndex) => (
                                <Grid container alignItems="center" mt={2} key={compareDateIndex}>
                                    <Grid item xs>
                                        <Typography gutterBottom variant="button">Date Range {compareDateIndex + 1}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <IconButton className={classes.crossIcon + " form-icon-btn"} onClick={() => handleRemoveDateCompare(compareDateIndex, i)}> <CloseIcon /> </IconButton>
                                    </Grid>
                                    <Grid container xs={12}>
                                        <Grid item xs={12} mb={2}>
                                            <Select value={date.fixedValue} onChange={(e) => handleCompareDateRangeType(e, compareDateIndex, i)} className='granularity_picker report_form_ui_input_select' size='small'
                                                IconComponent={DropDownIcon}
                                                MenuProps={{
                                                    classes: {
                                                        root: `form-select-menu`,
                                                    },
                                                }}
                                            >
                                                {COMPARE_DATE_RANGE.map((obj, i) => <MenuItem className={classes.menuDropdownItem + " menu-item"} key={i} value={obj.value}>{obj.label}</MenuItem>)}
                                            </Select>
                                        </Grid>

                                        {date.type === 'custom' ?
                                            <>
                                                <Grid item xs={5}>
                                                    <DatePicker
                                                        selected={LocalToUTC(date?.startDate)}
                                                        onChange={(date) => handleDateCompareSelect(date, compareDateIndex, i, 'startDate')}
                                                        selectsStart
                                                        startDate={new Date(date?.startDate)}
                                                        endDate={LocalToUTC(date?.endDate)}
                                                        className='date_picker'
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                    />
                                                </Grid>
                                                <Grid item xs={1}> To </Grid>
                                                <Grid item xs={5}>
                                                    <DatePicker
                                                        selected={LocalToUTC(date?.endDate)}
                                                        onChange={(date) => handleDateCompareSelect(date, compareDateIndex, i, 'endDate')}
                                                        selectsEnd
                                                        startDate={new Date(date?.startDate)}
                                                        endDate={LocalToUTC(date?.endDate)}
                                                        minDate={new Date(date?.startDate)}
                                                        className='date_picker'
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                    />
                                                </Grid>
                                            </> : null}
                                    </Grid>
                                </Grid>
                            ))}

                        </Grid>
                        {/* <Divider /> */}
                    </div>
                ))}
            </Box>

            {sheetsAvailable[selectedSheetIndex]?.sheetGranularities?.length ?
                <Box width="100%" height="10%" p={2}>
                    <Stack direction="row" width="100%" spacing={1} flexShrink={0} sx={{ my: 1 }}>
                        <Button width="100%" className="report_form_ui_btn primary text-btn-small mr-2 submit" variant="contained" color="primary" onClick={applyGranularityToAllReports} >
                            Apply Granularity
                        </Button>
                        <Button width="100%" className="report_form_ui_btn primary text-btn-small submit"
                            variant="contained" color="primary"
                            onClick={() => handleDeleteAllGranularitiesDialog('open')}>
                            Delete
                        </Button>
                    </Stack>
                </Box> : null}


            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className="modal-root"
                open={deleteGranularitiesDialog}
                onClose={() => setDeleteGranularitiesDialog(false)}
                closeAfterTransition
            >
                <Fade in={deleteGranularitiesDialog}>
                    <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                        <Box className="modal-content-simple">
                            <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete all the granularities ?`}</Typography>
                            <Box className="modal-footer-simple">
                                <Button onClick={() => handleDeleteAllGranularitiesDialog('close')} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                                <Button onClick={handleDeleteAllGranularities} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
                            </Box>
                        </Box>
                    </Box>
                </Fade>
            </Modal>

            {deleteSingleGranDialog ?
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className="modal-root"
                    open={deleteSingleGranDialog}
                    onClose={() => setDeleteSingleGranDialog(false)}
                    closeAfterTransition
                >
                    <Fade in={deleteSingleGranDialog}>
                        <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                            <Box className="modal-content-simple">
                                <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete ${tempSelectedGran?.displayTitle} from granularities ?`}</Typography>
                                <Box className="modal-footer-simple">
                                    <Button onClick={() => handleRemoveMeasure('close')} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                                    <Button onClick={handleDeleteGranularity} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Fade>
                </Modal>
                : null}

        </RootStyle>
    );
}
